var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "affiliation__detail" },
    [
      _c(
        "v-container",
        { staticClass: "affiliation__container" },
        [
          _c(
            "div",
            { staticClass: "product__stepper" },
            [
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    { attrs: { to: "/dashboard" } },
                    [
                      _c("v-icon", { staticClass: "icon-ic-flecha-izquierda" }),
                      _c("span", [_vm._v(" Afiliaciones Trabajadas /")])
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    { staticClass: "btn-close", attrs: { to: "/dashboard" } },
                    [_c("v-icon", [_vm._v("icon-ic-menu-copy")])],
                    1
                  ),
                  _c("span", [_vm._v("Detalle de Afiliación")])
                ],
                1
              ),
              (_vm.affiliation.dateProduct.concreted == "Concretada"
              ? true
              : false)
                ? _c(
                    "v-btn",
                    {
                      staticClass: "primary-button text black",
                      on: { click: _vm.download }
                    },
                    [
                      _vm._v("Descargar solicitud para imprimir"),
                      _c("i", { staticClass: "icon-printer" })
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("v-layout", { staticClass: "fluid-complete" }, [
            _c("div", { staticClass: "product__container" }, [
              _c("div", { staticClass: "product__left-side" }, [
                _c("div", { staticClass: "product-data" }, [
                  _c("h3", { staticClass: "detail__subtitle" }, [
                    _vm._v("Datos del PRODUCTO")
                  ]),
                  _vm.affiliation.associatedImages
                    ? _c("figure", { staticClass: "detail__img" }, [
                        _c("img", {
                          attrs: { src: _vm.affiliation.associatedImages[0] }
                        })
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "subtitle__info" }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(_vm.affiliation.sellerData.product || "--") + " "
                      )
                    ])
                  ]),
                  _c("ul", { staticClass: "product__item-container product" }, [
                    _c("li", { staticClass: "product__info-list" }, [
                      _c("p", [_vm._v(" Tipo de conexión ")]),
                      _c("span", [_vm._v(_vm._s(_vm.connectionType))])
                    ]),
                    _c("li", { staticClass: "product__info-list" }, [
                      _c("p", [_vm._v("Alquiler soles")]),
                      _c("span", [
                        _vm._v(
                          "S/ " +
                            _vm._s(_vm.affiliation.dateProduct.installationCost)
                        )
                      ])
                    ]),
                    _c("li", { staticClass: "product__info-list" }, [
                      _c("p", [_vm._v("Cantidad de productos ")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.affiliation.dateProduct.quantityEquipment ||
                              "--"
                          )
                        )
                      ])
                    ]),
                    _c("li", { staticClass: "product__info-list" }, [
                      _c("p", [_vm._v("Permanente o temporal")]),
                      _c("span", [_vm._v("Permanente")])
                    ]),
                    _c("li", { staticClass: "product__info-list" }, [
                      _c("p", [_vm._v("Multicomercio")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.affiliation.dateProduct.multicomerce || "--"
                          )
                        )
                      ])
                    ]),
                    _c("li", { staticClass: "product__info-list" }, [
                      _c("p", [_vm._v("Cuotas de instalación")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.affiliation.dateProduct.dues || "--"))
                      ])
                    ]),
                    _c("li", { staticClass: "product__info-list" }, [
                      _c("p", [_vm._v("Estado de solicitud")]),
                      _c(
                        "span",
                        {
                          class:
                            _vm.affiliation.dateProduct.concreted ==
                            "Concretada"
                              ? ""
                              : "redText"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.affiliation.dateProduct.concreted || "--"
                            )
                          )
                        ]
                      )
                    ]),
                    _c("li", { staticClass: "product__info-list" }, [
                      (_vm.affiliation.dateProduct.concreted == "Concretada"
                      ? false
                      : true)
                        ? _c("p", [_vm._v("Motivo de no afiliación")])
                        : _vm._e()
                    ]),
                    (_vm.affiliation.dateProduct.concreted == "Concretada"
                    ? false
                    : true)
                      ? _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            _vm._s(_vm.affiliation.dateProduct.reason || "--")
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _c("div", { staticClass: "seller-data" }, [
                  _c("h3", { staticClass: "detail__subtitle" }, [
                    _vm._v("Vendedor")
                  ]),
                  _c("p", [
                    _vm._v(
                      " " + _vm._s(_vm.affiliation.sellerData.seller || "--")
                    )
                  ]),
                  _c("em", [
                    _vm._v(_vm._s(_vm.affiliation.sellerData.team || "--"))
                  ]),
                  _c("em", [
                    _vm._v(_vm._s(_vm.affiliation.sellerData.channel || "--"))
                  ])
                ])
              ]),
              _c("div", { staticClass: "product__right" }, [
                _c(
                  "div",
                  {
                    staticClass: "client-data",
                    class: { active: _vm.dataClient },
                    on: {
                      click: function($event) {
                        _vm.openSlide()
                      }
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "d-flex" },
                      [
                        _c("v-icon", { staticClass: "icon-slide" }, [
                          _vm._v("icon-ic-arrow-open")
                        ]),
                        _c("h3", { staticClass: "detail__subtitle" }, [
                          _vm._v(" Datos del cliente")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "ul",
                      { staticClass: "detail__list-container cliente" },
                      [
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Nº de RUC / RUS")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.affiliation.dateOfClient.ruc || "--")
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Razón Social")]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.affiliation.dateOfClient.businessName ||
                                    "--"
                                )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Fecha - Hora")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.affiliation.dateOfClient.date || "--")
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Nombres")]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.affiliation.dateOfClient.name || "--"
                                )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Apellido Paterno")]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.affiliation.dateOfClient.paternalName ||
                                    "--"
                                )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Apellido Materno ")]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.affiliation.dateOfClient.maternalName ||
                                    "--"
                                )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Documento")]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.affiliation.dateOfClient.document || "--"
                                )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Teléfono Celular ")]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.affiliation.dateOfClient.cellPhone || "--"
                                )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Segundo Teléfono")]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.affiliation.dateOfClient.secondPhone ||
                                    "--"
                                )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Correo electrónico")]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.affiliation.dateOfClient.email || "--"
                                )
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "commerce-data",
                    class: { active: _vm.openCommerce },
                    on: {
                      click: function($event) {
                        _vm.openSlideCommerce()
                      }
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "d-flex" },
                      [
                        _c("v-icon", { staticClass: "icon-slide" }, [
                          _vm._v("icon-ic-arrow-open")
                        ]),
                        _c("h3", { staticClass: "detail__subtitle" }, [
                          _vm._v(" Datos del Comercio")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "ul",
                      { staticClass: "detail__list-container comercio" },
                      [
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Nombre Comercial")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.affiliation.commerceDate.businessName ||
                                  "--"
                              )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Giro Comercial")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.affiliation.commerceDate
                                  .commercialBusiness || "--"
                              )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [
                            _vm._v("Correo electrónico del comercio ")
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.affiliation.commerceDate.email || "--")
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("MCC Nacional")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.affiliation.commerceDate.mccNational || "--"
                              )
                            )
                          ])
                        ]),
                        _c(
                          "h3",
                          { staticClass: "detail__subtitle no-margin" },
                          [_vm._v(" Dirección Administrativa")]
                        ),
                        _c(
                          "ul",
                          {
                            staticClass: "detail__list-container administrative"
                          },
                          [
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Departamento")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .department || "--"
                                  )
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Provincia")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .province || "--"
                                  )
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Distrito")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .district || "--"
                                  )
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Tipo de vía")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .typeOfRoad || "--"
                                  )
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Nombre de vía")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .nameOfRoad || "--"
                                  )
                                )
                              ])
                            ]),
                            _c(
                              "ul",
                              { staticClass: "detail__list container__four" },
                              [
                                _c("li", { staticClass: "detail__list" }, [
                                  _c("em", [_vm._v("No.")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.affiliation.administrativeAddress
                                          .no || "--"
                                      )
                                    )
                                  ])
                                ]),
                                _c("li", { staticClass: "detail__list" }, [
                                  _c("em", [_vm._v("Km")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.affiliation.administrativeAddress
                                          .km || "--"
                                      )
                                    )
                                  ])
                                ]),
                                _c("li", { staticClass: "detail__list" }, [
                                  _c("em", [_vm._v("Manzana")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.affiliation.administrativeAddress
                                          .block || "--"
                                      )
                                    )
                                  ])
                                ]),
                                _c("li", { staticClass: "detail__list" }, [
                                  _c("em", [_vm._v("Lote")]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.affiliation.administrativeAddress
                                          .lote || "--"
                                      )
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Tipo de interior")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .typeOfInterior || "--"
                                  )
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Interior")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .interior || "--"
                                  )
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Referencia")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .reference || "--"
                                  )
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Teléfono Celular")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .cellPhone || "--"
                                  )
                                )
                              ])
                            ]),
                            _c("li", { staticClass: "detail__list" }, [
                              _c("em", [_vm._v("Teléfono Fijo")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.affiliation.administrativeAddress
                                      .phone || "--"
                                  )
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "attention__day",
                    class: { active: _vm.openAttention },
                    on: {
                      click: function($event) {
                        _vm.openSlideAttention()
                      }
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "d-flex" },
                      [
                        _c("v-icon", { staticClass: "icon-slide" }, [
                          _vm._v("icon-ic-arrow-open")
                        ]),
                        _c("h3", { staticClass: "detail__subtitle" }, [
                          _vm._v(" Jornada de atención")
                        ])
                      ],
                      1
                    ),
                    _c("ul", { staticClass: "detail__flex-list" }, [
                      _c("li", { staticClass: "detail__list" }, [
                        _c("em", [_vm._v("Días de atención del comercio")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.affiliation.dataOfAttention.days || "--")
                          )
                        ])
                      ]),
                      _c("li", { staticClass: "detail__list" }, [
                        _c("em", [_vm._v("Rango horario")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.affiliation.dataOfAttention.rangeOfSchedule ||
                                "--"
                            )
                          )
                        ])
                      ])
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "associated__bank",
                    class: { active: _vm.openAssociated },
                    on: {
                      click: function($event) {
                        _vm.openAssociatedBank()
                      }
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "d-flex" },
                      [
                        _c("v-icon", { staticClass: "icon-slide" }, [
                          _vm._v("icon-ic-arrow-open")
                        ]),
                        _c("h3", { staticClass: "detail__subtitle" }, [
                          _vm._v("Cuentas de banco Asociadas")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "ul",
                      { staticClass: "detail__list-container associated" },
                      [
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Tipo de moneda")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.affiliation.bankAccounts.typeOfCoins || "--"
                              )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Banco")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.affiliation.bankAccounts.bank || "--")
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Tipo de cuenta")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.affiliation.bankAccounts
                                  .typeOfBankAccount || "--"
                              )
                            )
                          ])
                        ]),
                        _c("li", { staticClass: "detail__list" }, [
                          _c("em", [_vm._v("Nº de cuenta")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.affiliation.bankAccounts.numberAccount ||
                                  "--"
                              )
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "associated__images",
                    class: { active: _vm.openImages },
                    on: {
                      click: function($event) {
                        _vm.openAssociatedImages()
                      }
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      { staticClass: "d-flex" },
                      [
                        _c("v-icon", { staticClass: "icon-slide" }, [
                          _vm._v("icon-ic-arrow-open")
                        ]),
                        _c("h3", { staticClass: "detail__subtitle" }, [
                          _vm._v("Imágenes Asociadas")
                        ])
                      ],
                      1
                    ),
                    _vm.affiliation.associatedImages
                      ? _c(
                          "ul",
                          { staticClass: "detail__images-container" },
                          _vm._l(_vm.affiliation.associatedImages, function(
                            image,
                            index
                          ) {
                            return _c(
                              "li",
                              { key: index, staticClass: "detail__image" },
                              [_c("img", { attrs: { src: image } })]
                            )
                          })
                        )
                      : _c("ul", { staticClass: "detail__images-container" }, [
                          _c("p", [
                            _vm._v("No se encontraron imágenes asociadas")
                          ])
                        ])
                  ],
                  1
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10b3ef5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b3ef5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/affiliation-detail.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-10b3ef5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/affiliation-detail.vue
// module chunks = 23